import {useTranslation} from "react-i18next";
import {Button, Col, Form} from "react-bootstrap";
import {Block, BoolSelect, FormGroup, Icon, Select, useForm} from "../../components";
import React, {useEffect, useState} from "react";
import { CustomFilter } from "./CustomFilter";
import {genRanHex} from "../../utils";

export default function AdminTab({getInputProps, disabled, useParentFormRef}) {
  const { t } = useTranslation();

  return (
    <>
      <Block title={t("stream.api.title")}>
        <FormGroup label={t("stream.api.environment")} {...getInputProps("api_environment")}>
          <Select isClearable={false}>
            <Option value="production">production</Option>
            <Option value="preprod">preprod</Option>
          </Select>
        </FormGroup>
      </Block>
      <ColumnMappingsGroup getInputProps={getInputProps}/>
      <CustomFiltersList {...getInputProps("custom_filters")} disabled={disabled} parentFormRef={useParentFormRef("custom_filters")} />
    </>)
}

function ColumnMappingsGroup({getInputProps}) {
  const { t } = useTranslation()
  const {onChange, disabled, name, value} = getInputProps("column_mapping")
  const [testValue, setTestValue] = useState(value ?? '')
  useEffect(() => {
    setTestValue(value ?? '')
  }, [value])
  
  const textOnChange = (e)=>{
    setTestValue(e.target.value)
    onChange(e)
  }

  return (
    <>
      <Block title={t("stream.column_mapping.title")}>
        <FormGroup input="textarea" rows={7} disabled={disabled} name={name} onChange={textOnChange} value={testValue} />
      </Block>
    </>
  )
}

function CustomFiltersList({disabled, ...props}) {
  const { t } = useTranslation();

  const [filters, setFilters] = useState(filtersWithIds())

  // This is a hack
  // If not present, when deleting last filter, the child form is unregistered (as a useEffect cleanup), therefore the
  // form is submitted with its initial value
  // This forces the child form to stay registered and have therefore at least an empty array
  useForm({
    initialValues: {},
    parentFormRef: props.parentFormRef,
    preProcess: (data) => {
      return []
    }
  })

  useEffect(() => {
    setFilters(filtersWithIds())
  }, [props.value])

  function filterWithId(filter) {
    return {filter, id: genRanHex()}
  }

  function filtersWithIds() {
    return (props.value || []).map(el => filterWithId(el))
  }

  const onDelete = (i) => {
    setFilters(filters.filter(el => el.id !== i))
  }

  const addFilter = () => {
    setFilters([...filters, filterWithId()])
  }

  function isDisabled() {
    if (typeof disabled === 'function') { return disabled("custom_filters") }
    return disabled
  }

  return (
    <>
      {filters.map(filter => (
        <CustomFilter
          key={filter.id}
          value={filter.filter}
          disabled={isDisabled()}
          parentFormRef={props.parentFormRef}
          onDelete={() => onDelete(filter.id)}
        />
      ))}
      {!isDisabled() && <Button onClick={addFilter} disabled={isDisabled()}>{t("custom_filter.add")}</Button>}
    </>
  )
}
